(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ke-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init() {
    const previewEnd = Date.now() + 1080000;
    document.querySelectorAll('.ke-page [data-ke-countdown]').forEach(el => {
      if (el.dataset.initialized) return;
      el.dataset.initialized = 'true';
      const demo = el.dataset.mode === 'demo';
      if (demo && el.dataset.preview !== 'true') return;
      let end = demo ? previewEnd : Date.parse(el.dataset.end);
      if (el.dataset.mode === 'session') {
        const key = 'klyr-editorial-offer-end-v1';
        try {
          const saved = Number(sessionStorage.getItem(key));
          end = saved > 0 ? saved : previewEnd;
          if (!(saved > 0)) sessionStorage.setItem(key, String(end));
        } catch (_) {
          end = previewEnd;
        }
      }
      if (!Number.isFinite(end)) return;
      let timer;
      const tick = () => {
        const remaining = Math.max(0, Math.ceil((end - Date.now()) / 1000));
        if (!el.isConnected || !remaining) {
          el.hidden = true;
          clearInterval(timer);
          return;
        }
        const days = Math.floor(remaining / 86400);
        const hours = Math.floor(remaining / 3600) % 24;
        const mins = Math.floor(remaining / 60) % 60;
        const seconds = remaining % 60;
        const pad = n => String(n).padStart(2, '0');
        el.querySelector('.ke-clock').textContent = (days ? days + 'd ' : '') +
          (remaining >= 3600 ? pad(hours) + ':' : '') + pad(mins) + ':' + pad(seconds);
        el.hidden = false;
      };
      timer = setInterval(tick, 1000);
      tick();
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klyr-customer-stories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('klyr-customer-stories')) {
  customElements.define('klyr-customer-stories', class extends HTMLElement {
    connectedCallback() {
      if(this._events) return;
      this._events=new AbortController();
      this.classList.add('is-enhanced');
      this.querySelectorAll('.kcs__toggle').forEach(button=>{
        button.hidden=false;
        button.addEventListener('click',()=>{
          const expanded=button.getAttribute('aria-expanded')==='true';
          const card=button.closest('.kcs__card');
          const top=card.getBoundingClientRect().top;
          button.setAttribute('aria-expanded',String(!expanded));
          card.querySelector('.kcs__text').classList.toggle('is-open',!expanded);
          if(expanded && top<0) card.scrollIntoView({block:'start',inline:'nearest',behavior:'instant'});
        },{signal:this._events.signal});
      });
      const track=this.querySelector('.kcs__track');
      const buttons=[...this.querySelectorAll('[data-direction]')];
      const update=()=>{const media=track.querySelector('.kcs__media');if(media)this.style.setProperty('--kcs-nav-top',`${media.getBoundingClientRect().height/2}px`);const max=track.scrollWidth-track.clientWidth;const x=Math.max(0,track.scrollLeft);buttons[0].disabled=x<2;buttons[1].disabled=x>=max-2;this.style.setProperty('--kcs-progress',`${max>0?x/max*900:0}%`);};
      buttons.forEach(button=>button.addEventListener('click',()=>{const card=track.querySelector('.kcs__card');const gap=parseFloat(getComputedStyle(track).gap)||0;track.scrollBy({left:Number(button.dataset.direction)*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});},{signal:this._events.signal}));
      track.addEventListener('scroll',update,{passive:true,signal:this._events.signal});
      this._resize=new ResizeObserver(update);this._resize.observe(track);update();
    }
    disconnectedCallback(){this._events?.abort();this._events=null;this._resize?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klyr-home-results"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('klyr-results'))customElements.define('klyr-results',class extends HTMLElement{
connectedCallback(){if(this.events)return;this.events=new AbortController();const track=this.querySelector('.krs__track'),buttons=[...this.querySelectorAll('[data-step]')];const update=()=>{const max=track.scrollWidth-track.clientWidth,x=Math.max(0,track.scrollLeft);buttons[0].disabled=x<2;buttons[1].disabled=x>=max-2;this.style.setProperty('--krs-progress',`${max>0?Math.min(1,x/max)*400:0}%`)};buttons.forEach(b=>b.addEventListener('click',()=>{const pair=track.querySelector('.krs__pair');if(!pair)return;track.scrollBy({left:Number(b.dataset.step)*(pair.getBoundingClientRect().width+(parseFloat(getComputedStyle(track).gap)||0)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})},{signal:this.events.signal}));track.addEventListener('scroll',update,{passive:true,signal:this.events.signal});this.observer=new ResizeObserver(update);this.observer.observe(track);update()}
disconnectedCallback(){this.events?.abort();this.events=null;this.observer?.disconnect()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klyr-home-stories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('klyr-customer-stories')) {
  customElements.define('klyr-customer-stories', class extends HTMLElement {
    connectedCallback() {
      if(this._events) return;
      this._events=new AbortController();
      this.classList.add('is-enhanced');
      this.querySelectorAll('.kcs__toggle').forEach(button=>{
        button.hidden=false;
        button.addEventListener('click',()=>{
          const expanded=button.getAttribute('aria-expanded')==='true';
          const card=button.closest('.kcs__card');
          const top=card.getBoundingClientRect().top;
          button.setAttribute('aria-expanded',String(!expanded));
          card.querySelector('.kcs__text').classList.toggle('is-open',!expanded);
          if(expanded && top<0) card.scrollIntoView({block:'start',inline:'nearest',behavior:'instant'});
        },{signal:this._events.signal});
      });
      const track=this.querySelector('.kcs__track');
      const buttons=[...this.querySelectorAll('[data-direction]')];
      const update=()=>{const media=track.querySelector('.kcs__media');if(media)this.style.setProperty('--kcs-nav-top',`${media.getBoundingClientRect().height/2}px`);const max=track.scrollWidth-track.clientWidth;const x=Math.max(0,track.scrollLeft);buttons[0].disabled=x<2;buttons[1].disabled=x>=max-2;this.style.setProperty('--kcs-progress',`${max>0?x/max*900:0}%`);};
      buttons.forEach(button=>button.addEventListener('click',()=>{const card=track.querySelector('.kcs__card');const gap=parseFloat(getComputedStyle(track).gap)||0;track.scrollBy({left:Number(button.dataset.direction)*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});},{signal:this._events.signal}));
      track.addEventListener('scroll',update,{passive:true,signal:this._events.signal});
      this._resize=new ResizeObserver(update);this._resize.observe(track);update();
    }
    disconnectedCallback(){this._events?.abort();this._events=null;this._resize?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klyr-home-trustpilot"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('klyr-trust-reviews'))customElements.define('klyr-trust-reviews',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const track=this.querySelector('.kh-trust-track'),buttons=this.querySelectorAll('button');const update=()=>{buttons[0].disabled=track.scrollLeft<2;buttons[1].disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2};buttons.forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:Number(button.dataset.direction)*(track.firstElementChild.getBoundingClientRect().width+16),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));track.addEventListener('scroll',update,{passive:true});this.resize=new ResizeObserver(update);this.resize.observe(track);update()}disconnectedCallback(){this.resize?.disconnect();this.ready=false}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klyr-results"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('klyr-results'))customElements.define('klyr-results',class extends HTMLElement{
connectedCallback(){if(this.events)return;this.events=new AbortController();const track=this.querySelector('.krs__track'),buttons=[...this.querySelectorAll('[data-step]')];const update=()=>{const max=track.scrollWidth-track.clientWidth,x=Math.max(0,track.scrollLeft);buttons[0].disabled=x<2;buttons[1].disabled=x>=max-2;this.style.setProperty('--krs-progress',`${max>0?Math.min(1,x/max)*400:0}%`)};buttons.forEach(b=>b.addEventListener('click',()=>{const pair=track.querySelector('.krs__pair');if(!pair)return;track.scrollBy({left:Number(b.dataset.step)*(pair.getBoundingClientRect().width+(parseFloat(getComputedStyle(track).gap)||0)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})},{signal:this.events.signal}));track.addEventListener('scroll',update,{passive:true,signal:this.events.signal});this.observer=new ResizeObserver(update);this.observer.observe(track);update()}
disconnectedCallback(){this.events?.abort();this.events=null;this.observer?.disconnect()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msi-article"] && !Shopify.designMode) return;
  try {
    
function initMsi(root) {
  root.querySelectorAll('.msi-article').forEach(article => {
    const sticky = article.parentElement.querySelector('.msi-sticky');
    const offers = Array.from(article.querySelectorAll('.msi-offer'));
    if (sticky && offers.length) {
      const update = () => { sticky.hidden = !(offers[0].getBoundingClientRect().bottom < 0 && !offers.some(el => { const r = el.getBoundingClientRect(); return r.top < innerHeight && r.bottom > 0; })); };
      const observer = new IntersectionObserver(update);
      offers.forEach(el => observer.observe(el));
      let scheduled = false;
      window.addEventListener('scroll', () => { if (!scheduled) { scheduled = true; requestAnimationFrame(() => { update(); scheduled = false; }); } }, {passive: true});
      update();
    }
    article.querySelectorAll('video').forEach(video => {
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) { video.autoplay = false; video.pause(); return; }
      const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) video.play().catch(() => {}); else video.pause(); }), {threshold: 0.15});
      observer.observe(video);
    });
  });
}
initMsi(document);
document.addEventListener('shopify:section:load', event => initMsi(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scp-editorial-hero"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(){document.querySelectorAll('.ke-page [data-ke-countdown]').forEach(el=>{if(el.dataset.initialized)return;el.dataset.initialized='true';const demo=el.dataset.mode==='demo';if(demo&&el.dataset.preview!=='true'){el.hidden=true;el.style.display='none';return}const end=demo?Date.now()+1080000:Date.parse(el.dataset.end);if(!Number.isFinite(end)){el.style.display='none';return}const tick=()=>{if(!el.isConnected){clearInterval(timer);return}const remaining=Math.max(0,Math.ceil((end-Date.now())/1000));if(!remaining){el.style.display='none';clearInterval(timer);return}const mins=Math.floor(remaining/60);el.querySelector('.ke-clock').textContent=String(mins).padStart(2,'0')+':'+String(remaining%60).padStart(2,'0')};const timer=setInterval(tick,1000);tick()})}init();document.addEventListener('shopify:section:load',init)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scp-editorial-reasons"] && !Shopify.designMode) return;
  try {
    
(()=>{
const videos=new Map();
function init(root=document){
root.querySelectorAll('.scp-native-video, [data-scp-scroll-video]').forEach(video=>{
if(videos.has(video))return;
video.muted=true;video.defaultMuted=true;video.playsInline=true;video.controls=false;
const button=video.nextElementSibling;
let active=false,pending=false,disposed=false,epoch=0;
const reset=()=>{try{video.currentTime=0}catch(e){}};
const stop=()=>{active=false;epoch++;video.pause();reset();button.hidden=true};
const play=()=>{
if(disposed||!active||document.hidden||pending)return;
video.muted=true;pending=true;
const generation=epoch;
const promise=video.play();
Promise.resolve(promise).then(()=>{
pending=false;
if(disposed||!active||document.hidden)video.pause();
else button.hidden=true;
}).catch(()=>{
pending=false;
if(active&&!document.hidden&&generation===epoch)button.hidden=false;
});
};
const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>{
for(const entry of entries){
if(entry.isIntersecting&&entry.intersectionRatio>=0.2&&!document.hidden){
if(!active){active=true;epoch++;reset()}
play();
}else if(!entry.isIntersecting)stop();
}
},{threshold:[0,0.2]}):null;
if(observer)observer.observe(video);else{active=true;play()}
const retry=()=>{if(video.paused)play()};
const visibility=()=>{if(document.hidden)stop();else if(observer){observer.unobserve(video);observer.observe(video)}else{active=true;play()}};
const manual=()=>{active=true;reset();play()};
video.addEventListener('loadeddata',retry);
video.addEventListener('canplay',retry);
video.addEventListener('playing',()=>{if(!active||document.hidden)video.pause();else button.hidden=true});
button.addEventListener('click',manual);
video.addEventListener('click',()=>{if(video.paused)manual()});
document.addEventListener('touchend',retry,{passive:true});
document.addEventListener('visibilitychange',visibility);
window.addEventListener('pageshow',visibility);
videos.set(video,()=>{disposed=true;observer?.disconnect();stop();document.removeEventListener('touchend',retry);document.removeEventListener('visibilitychange',visibility);window.removeEventListener('pageshow',visibility);videos.delete(video)});
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
document.addEventListener('shopify:section:load',e=>init(e.target));
document.addEventListener('shopify:section:unload',e=>{videos.forEach((cleanup,video)=>{if(e.target.contains(video))cleanup()})});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["us-offer-validation"]) return;
  try {
    
  if (!customElements.get('us-offer-validation')) {
    customElements.define('us-offer-validation', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.config = JSON.parse(this.querySelector('[data-test-config]').textContent);
        this.text = this.config.text;
        this.querySelector('[data-quantity]').addEventListener('change', () => this.update());
        this.querySelector('[data-selection]').addEventListener('submit', event => { event.preventDefault(); this.perform(() => this.addSelection()); });
        this.querySelector('[data-run]').addEventListener('click', () => this.perform(() => this.run()));
        this.querySelector('[data-remove]').addEventListener('click', () => this.perform(async () => { await this.removeTestItems(); this.show(this.text.removed); }));
        this.update();
      }
      update() { const qty = Number(this.querySelector('[data-quantity]').value); this.querySelectorAll('[data-bottle]').forEach(label => { label.hidden = Number(label.dataset.bottle) > qty; }); }
      show(message) { this.querySelector('[data-status]').textContent = message; }
      async request(path, body) {
        const response = await fetch(this.config.root + path, body ? {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)} : {});
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || this.text.error);
        return data;
      }
      async perform(action) {
        if (this.busy) return;
        this.busy = true;
        this.querySelectorAll('button,select').forEach(el => { el.disabled = true; });
        this.querySelector('[data-checkout]').hidden = true;
        try { await action(); } catch (error) { this.show(error.message); }
        finally { this.busy = false; this.querySelectorAll('button,select').forEach(el => { el.disabled = false; }); }
      }
      async checkSession() {
        const cart = await this.request('cart.js');
        if (cart.currency !== 'USD') throw new Error(this.text.currency);
        if (cart.items.some(item => item.product_id !== this.config.productId)) throw new Error(this.text.other_items);
        return cart;
      }
      async removeTestItems() {
        const cart = await this.request('cart.js');
        const updates = {};
        cart.items.filter(item => item.product_id === this.config.productId).forEach(item => { updates[item.key] = 0; });
        if (Object.keys(updates).length) await this.request('cart/update.js', {updates});
        this.querySelector('[data-checkout]').hidden = true;
      }
      async buildCart(qty, subscription, shades) {
        await this.checkSession();
        await this.removeTestItems();
        const items = shades.slice(0,qty).map(id => ({id:Number(id),quantity:1,...(subscription ? {selling_plan:this.config.plans[qty]} : {}),properties:{_offer_test:'us-2026-09-23'}}));
        await this.request('cart/add.js',{items});
        return this.request('cart.js');
      }
      assess(cart, qty, subscription) {
        const expected = (subscription ? {1:4900,2:6900,4:11600} : {1:5900,2:8900,4:15600})[qty];
        const lines = cart.items.filter(item => item.product_id === this.config.productId);
        const actual = lines.reduce((sum,item) => sum + item.final_line_price,0);
        const pass = cart.currency === 'USD' && cart.item_count === qty && cart.total_price === expected && actual === expected && lines.every(item => item.final_line_price === expected / qty * item.quantity && (subscription ? item.selling_plan_allocation?.selling_plan?.id === this.config.plans[qty] : !item.selling_plan_allocation));
        return {pass,expected,actual,total:cart.total_price,lines:lines.map(item => ({variant:item.variant_id,quantity:item.quantity,unit:item.final_price,plan:item.selling_plan_allocation?.selling_plan?.id || null,discounts:item.discounts}))};
      }
      money(cents) { return new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(cents/100); }
      async addSelection() {
        const qty = Number(this.querySelector('[data-quantity]').value);
        const subscription = this.querySelector('[data-purchase]').value === 'subscription';
        const shades = [...this.querySelectorAll('[data-variant]')].map(input => Number(input.value));
        const cart = await this.buildCart(qty,subscription,shades);
        const result = this.assess(cart,qty,subscription);
        this.show((result.pass ? this.text.pass : this.text.fail) + ' — ' + this.money(result.total));
        this.querySelector('[data-checkout]').hidden = !result.pass;
        this.dataset.lastResult = JSON.stringify(result);
      }
      async run() {
        await this.checkSession();
        const output = this.querySelector('[data-results]'); output.replaceChildren();
        const variants = this.config.variants.filter(variant => variant.available);
        if (!variants.length) throw new Error(this.text.error);
        const cases = [];
        for (const subscription of [true,false]) for (const qty of [1,2,4]) {
          for (const variant of variants) cases.push({qty,subscription,label:variant.title,shades:Array(qty).fill(variant.id)});
          if (qty > 1 && variants.length > 1) cases.push({qty,subscription,label:this.text.mixed,shades:Array.from({length:qty},(_,i)=>variants[i % variants.length].id)});
        }
        const results = [];
        try {
          for (const test of cases) {
            this.show(this.text.running + ' ' + (results.length + 1) + '/' + cases.length);
            const cart = await this.buildCart(test.qty,test.subscription,test.shades);
            const result = this.assess(cart,test.qty,test.subscription);
            results.push({...test,...result});
            const row = document.createElement('li');
            row.textContent = (result.pass ? this.text.pass : this.text.fail) + ': ' + test.qty + ' × ' + test.label + ' / ' + (test.subscription ? this.text.subscription : this.text.once) + ' — ' + this.money(result.total);
            output.append(row);
            this.dataset.results = JSON.stringify(results);
            if (!result.pass) throw new Error(this.text.fail + ': ' + this.money(result.total) + ' / ' + this.text.expected + ' ' + this.money(result.expected));
          }
          this.show(this.text.complete + ' ' + results.length + '/' + cases.length);
        } finally { await this.removeTestItems(); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
